import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  onApply = new EventEmitter();
  onCancel = new EventEmitter();

  ngOnInit(): void {
  }

  ok(): void {
    this.onApply.emit();
  }

  cancel(): void {
    this.dialogRef.close();
    this.onCancel.emit();
  }
}
